const o = 12;
export {
  o as BASE_FONT
};
